import { Subscribable, SubscribableOrValue } from 'knockout';
import { GridColumnModel } from '../column';
import GridColumnPicker from './base';

export interface GridThresholdColumnPickerConfig {
    threshold: SubscribableOrValue<number>
}

export default class GridThresholdColumnPicker<T> extends GridColumnPicker<T> {
    threshold: Subscribable<number>

    constructor(config: GridThresholdColumnPickerConfig) {
        super();

        this.threshold = ko.flattenComputed(config.threshold);
    }

    override pick(columns: Array<GridColumnModel<T>>) {
        const target = super.pick(columns);

        if (target != undefined) {
            return columns
                .filter(column => this.isSibling(target, column))
                .sort((c1, c2) => c1.index() - c2.index())[0];
        }
    }

    isSibling(target: GridColumnModel<T>, column: GridColumnModel<T>) {
        return column.height() <= target.height() + this.threshold();
    }
}